// import React
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// import Firebase
// Nothing to import yet... auth and firestore are coming...

// import Routes
import Home from "./PublicRoutes/Home";
import Contact from "./PublicRoutes/Contact";

// import CSS
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path='/'
          element={<Home />}
        />
        <Route
          path='/Contact'
          element={<Contact />}
        />
      </Routes>
    </Router>
  );
}

export default App;
